import { jsx as e, jsxs as a } from "react/jsx-runtime";
import { ActionMenuItem as n } from "@systemeio/ui";
import { InfoIcon as o, BinIcon as m, PenIcon as c, DownloadIcon as s } from "@systemeio/ui/icons";
import { useTranslation as l } from "../../i18n.mjs";
function u({ label: i, ...r }) {
  const { t } = l();
  return /* @__PURE__ */ e(
    n,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: i ?? /* @__PURE__ */ a("div", { className: "text-text-primary group-hover:text-brand-primary main-transition-colors flex items-center gap-2", children: [
        /* @__PURE__ */ e(
          o,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        t("file_manager.file_details")
      ] }),
      ...r,
      onClick: r.onClick,
      children: void 0
    }
  );
}
function x({ label: i, ...r }) {
  const { t } = l();
  return /* @__PURE__ */ e(
    n,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: i ?? /* @__PURE__ */ a("div", { className: "text-text-primary group-hover:text-brand-primary main-transition-colors flex items-center gap-2", children: [
        /* @__PURE__ */ e(
          m,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        t("file_manager.delete")
      ] }),
      ...r,
      onClick: r.onClick,
      children: void 0
    }
  );
}
function g({ label: i, ...r }) {
  const { t } = l();
  return /* @__PURE__ */ e(
    n,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: i ?? /* @__PURE__ */ a("div", { className: "text-text-primary group-hover:text-brand-primary main-transition-colors flex items-center gap-2", children: [
        /* @__PURE__ */ e(
          c,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        t("file_manager.rename")
      ] }),
      ...r,
      onClick: r.onClick,
      children: void 0
    }
  );
}
function b({ label: i, ...r }) {
  const { t } = l();
  return /* @__PURE__ */ e(
    n,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: i ?? /* @__PURE__ */ a("div", { className: "text-text-primary group-hover:text-brand-primary main-transition-colors flex items-center gap-2", children: [
        /* @__PURE__ */ e(
          s,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        t("file_manager.download")
      ] }),
      ...r,
      onClick: r.onClick,
      children: void 0
    }
  );
}
export {
  x as FileActionMenuDeleteItem,
  u as FileActionMenuDetailsItem,
  b as FileActionMenuDownloadItem,
  g as FileActionMenuRenameItem
};
